import { z } from "zod";

export const getArticleGroupParamSchema = z.object({
	articleGroupId: z.uuid(),
});

export type GetArticleGroupParamSchema = z.infer<typeof getArticleGroupParamSchema>;
